/**
 * @module Permission
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PermissionDirective } from '@app/services/permissions/permission.directive';
import { PermissionContextService } from '@app/services/permissions/permission-context.service';
import { PermissionValidationService } from '@app/services/permissions/permission-validation.service';

/**
 * Module that encapsulates the permission functionality within the application.
 *
 * This module declares, imports, and provides a set of permission-related functionality,
 * that can be used in other modules within the Angular application.
 */
@NgModule({
	declarations: [PermissionDirective],
	imports: [CommonModule],
	exports: [PermissionDirective],
	providers: [
		PermissionValidationService,
		PermissionContextService,
	],
})
export class PermissionModule { }
